import { useEffect, useRef } from 'react';
import { useToast } from './ToastProvider';
import { subscribeToAuthEvents, AUTH_EVENT_TYPES } from '../../utils/authEvents';

const RateLimitToastListener = () => {
  const toast = useToast();
  const lastToastRef = useRef(0);

  useEffect(() => {
    const unsubscribe = subscribeToAuthEvents((event) => {
      if (event?.type !== AUTH_EVENT_TYPES.RATE_LIMITED) return;

      const now = Date.now();
      if (now - lastToastRef.current < 3000) return;
      lastToastRef.current = now;

      const retryAfter = event.payload?.retryAfter;
      const msg = retryAfter
        ? `You're doing that too fast. Please wait ${retryAfter}s and try again.`
        : event.payload?.reason || 'You are making requests too quickly. Please slow down.';
      toast.error(msg);
    });
    return unsubscribe;
  }, [toast]);

  return null;
};

export default RateLimitToastListener;
